import { useState } from 'react';
// material
import { Container, Typography, Card, Tab, Box, Stack } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';

// components
import Page from '../components/Page';
import PaymentsList from '../components/payments/PaymentsList';
import PendingPayments from '../components/payments/PendingPayments';
import SuccessPayments from '../components/payments/SuccessPayment';

export default function Paymentss() {
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Page title="Instalments">
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Instalments
            </Typography>
          </Stack>
          <Card>
            <Box sx={{ width: '100%', marginTop: '20px' }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange}>
                    <Tab label="Dues" value="1" />
                    <Tab label="Success" value="2" />
                    <Tab label="Failed" value="3" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <PendingPayments />
                </TabPanel>
                <TabPanel value="2">
                  <SuccessPayments/>
                </TabPanel>
                <TabPanel value="3">
                  <PaymentsList status={'FAILED'}  />
                </TabPanel>
              </TabContext>
            </Box>
          </Card>
        </Container>
      </Page>
    </>
  );
}
